import React from "react";
import {
    Dialog,
    DialogTitle,
    IconButton,
    Box,
    Typography,
    Stack,
    useMediaQuery,
    useTheme,
    Fade
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GroupIcon from "@mui/icons-material/Group";
import AccessTimeIcon from "@mui/icons-material/AccessTime";


const Transition = React.forwardRef(function Transition(props, ref) {
    return (
        <Fade
            ref={ref}
            timeout={{ enter: 800, exit: 800 }} // slow close
            {...props}
        />
    );
});

const AllSelectedLocationsDialog = ({ open, onClose, locations, setSelectedLocationIndex, hanldeOpenPermissionDialog }) => {

    console.log("locations", locations);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={"xs"}
            fullWidth
            fullScreen={fullScreen}
            transitionDuration={500}
            PaperProps={{
                sx: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottomLeftRadius: !fullScreen && 10,
                    borderBottomRightRadius: !fullScreen && 10,
                    p: 2,
                    width: "100%",
                    mx: "auto",
                    mt: fullScreen ? "auto" : undefined,
                    maxHeight: "80vh", // Ensures it doesn't overflow
                    overflow: "hidden", // Keeps scroll within dialog
                    display: "flex",
                    flexDirection: "column"
                },
            }}
        >
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <DialogTitle sx={{ p: 0, fontSize: 16, fontWeight: 600 }}>
                    all selected locations
                </DialogTitle>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Location List */}
            <Box sx={{ mt: 2, maxHeight: "65vh", overflowY: "auto" }}>
                <Stack spacing={2}>
                    {locations?.map((loc, idx) => {
                        return (
                            <Box
                                key={`${loc.name}-${idx}`}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* Left part */}
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <LocationOnIcon sx={{ color: "#0037B7", mt: "2px" }} />
                                    <Box>
                                        <Typography
                                            sx={{ fontWeight: 600, fontSize: 14, color: "#1A1A1A" }}
                                        >
                                            {loc?.businessLocationName}
                                        </Typography>
                                        {/* <Typography sx={{ fontSize: 13, color: "#6E6E6E" }}>
                                            days : {loc.days}
                                        </Typography> */}
                                    </Box>
                                </Box>

                                {/* Right part */}
                                <Box sx={{ display: "flex", gap: 1, mt: 0.5 }}>
                                    <IconButton onClick={() => {
                                        setSelectedLocationIndex(idx);
                                        hanldeOpenPermissionDialog()
                                    }}>
                                        <GroupIcon sx={{ color: "#374957", mx: 1 }} />
                                    </IconButton>
                                    <IconButton>
                                        <AccessTimeIcon sx={{ color: "#374957" }} />
                                    </IconButton>
                                    {/* <GroupIcon sx={{ color: "#374957", fontSize: 18 }} />
                                    <AccessTimeIcon sx={{ color: "#374957", fontSize: 18 }} /> */}
                                </Box>
                            </Box>
                        )
                    })}

                </Stack>
            </Box>
        </Dialog>
    );
};

export default AllSelectedLocationsDialog;
